export const downloadFileWithPreview = (urls: string, preview: boolean) => {
  const link = document.createElement('a');
  link.href = urls;
  document.body.appendChild(link);
  try {
    if (preview) {
      window.open(urls, '_blank');
    } else {
      link.click();
    }
  } finally {
    document.body.removeChild(link);
  }
};
